export const CancelReasonMissingFeatures = {
  i18nKey: 'PARTNER_CANCELLATION_REASONS.MISSING_FEATURES',
  value: 'missing features we need',
};
export const CancelReasonHavingTroubled = {
  i18nKey: 'PARTNER_CANCELLATION_REASONS.HAVING_TROUBLE',
  value: 'having trouble getting started',
};
export const CancelReasonTooExpensive = {
  i18nKey: 'PARTNER_CANCELLATION_REASONS.TOO_EXPENSIVE',
  value: 'too expensive',
};
export const CancelReasonNotLooking = {
  i18nKey: 'PARTNER_CANCELLATION_REASONS.NOT_LOOKING',
  value: 'not what I was looking for',
};
export const CancelReasonFoundBetter = {
  i18nKey: 'PARTNER_CANCELLATION_REASONS.FOUND_BETTER',
  value: 'found a better alternative',
};
export const CancelReasonOther = {
  i18nKey: 'PARTNER_CANCELLATION_REASONS.OTHER',
  value: 'other',
};

export const PartnerFreeTrialCancellationReasons = [
  CancelReasonMissingFeatures,
  CancelReasonHavingTroubled,
  CancelReasonTooExpensive,
  CancelReasonNotLooking,
  CancelReasonFoundBetter,
  CancelReasonOther,
];
